module.exports = __webpack_public_path__ + "img/icomoon.03c9f06.svg";